/* eslint-disable sort-keys */
import * as core from '../../../../../../../core'

import { query } from './summary.query'

export const RESOURCE = {
  payload: {
    alias: 'summary',
    content: {
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
      segments: [
        {
          name: 'Summary',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'affiliates.table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'summary',
          query: {},
        },
      ],
    },
    description:
      'Summary statistics for assessment of all organizations within an institution',
    name: 'summary',
    query: {},
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
